module.exports = __webpack_public_path__ + "img/01 - Copy.55c5621a.jpg";